<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link mt8" to="/">
        <img class="header-logo hidden-switch" src="@/assets/logo/logo_moneypay_small.svg" height="40">
        <!--        <h1 v-else class="sidebar-title">{{ title }} </h1>-->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link mt15" to="/">
        <img class="header-logo" src="@/assets/logo/ezpay_logo.svg" height="45">
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Vue Admin Template',
      logo: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.header-logo {
  padding-top: 10px;
}
.hidden-switch {
  margin-top: 3px;
  margin-left: 13px;
}
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
 position: relative;
  width: 265px;
  height: 60px;
  line-height: 60px;
  display: inline-block;
  // text-align: center;
  margin-left: 24px;
  overflow: hidden;
  background: #fff;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    line-height: 50px;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;  font-family: 'Inter-SemiBold';
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    width: 56px;
    margin-left: 5px;
    .sidebar-logo {

    }
  }
}

.mt8{
    margin-top: 8px;
}
.mt15{
    margin-top: 15px;
}
</style>
